import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from './components/Layout.vue'
import Requisition from './components/PurchaseReq.vue'
import History from './components/History.vue'
import GroupView from './components/GroupView.vue'
import GroupOptionsView from './components/GroupOptionsView.vue'
import Filter from './components/Filter.vue'
import Catalog from './components/Catalog.vue'
import Dice from './components/Dice.vue'
import PostDice from './components/PostDice.vue'
import WalkThrough from './components/WalkThrough.vue'

Vue.use(VueRouter)

const routes = [
    { path: '/', name: 'home', component: Layout },
    { path: '/req', name: 'Purchase_Req', component: Requisition },
    { path: '/history', name: 'history', component: History },
    { path: '/group', component: GroupView },
    { path: '/groupOptions', component: GroupOptionsView },
    { path: '/filter', name: 'filter', component: Filter },
    { path: '/catalog', name: 'catalog', component: Catalog },
    { path: '/dice', name: 'dice', component: Dice },
    { path: '/postdice', name: 'postdice', component: PostDice },
    { path: '/walkthrough', name: 'walkthrough', component: WalkThrough },
]

const router = new VueRouter({
    mode: 'history',
    base: 'demo',
    routes
})

export default router;